import React from "react";
import {Tag as AntdTag} from "antd";
import {useTranslation} from "react-i18next";
import cn from "classnames";
// local
import {color as tagColor} from "constants/color.consts";

export const Tag = ({
  text,
  bold,
  normal,
  needTranslation,
  large,
  medium,
  small,
  tiny,
  round,
  uppercase,
  color,
  borderColor,
  noBackground,
  prefixIcon,
  suffixIcon,
  miniSelectView,
  mediumSelectView,
  disabled,
  addClass,
  ...props
}) => {
  const {t} = useTranslation();
  const resolvedBorderColor = tagColor[borderColor ?? color] ?? borderColor ?? color;
  return (
    (!!text || !!prefixIcon || !!suffixIcon) && (
      <AntdTag
        className={cn(
          "custom-tag",
          {__large: !!large},
          {__medium: !!medium},
          {__small: !!small},
          {__tiny: !!tiny},
          {__uppercase: !!uppercase},
          {__bold: !!bold},
          {__normal: !!normal},
          {__round: !!round},
          {__disabled: !!disabled},
          {"__no-background": !!noBackground},
          {"__mini-select-view": !!miniSelectView},
          {"__medium-select-view": !!mediumSelectView},
          {[addClass]: !!addClass}
        )}
        color={!noBackground && (tagColor[color] ?? color)}
        style={{
          color: noBackground && (tagColor[color] ?? color),
          borderColor: resolvedBorderColor,
        }}
        {...props}
      >
        {prefixIcon}
        {needTranslation ? t(text) : text}
        {suffixIcon}
      </AntdTag>
    )
  );
};
